import React, { createContext, useContext } from "react";
import useGhostUser from "../Hooks/useGhostUser";

const GhostModeContext = createContext(null);

export const GhostModeProvider = ({ children }) => {
  const ghostUser = useGhostUser();
  return (
    <GhostModeContext.Provider value={ghostUser}>
      {children}
    </GhostModeContext.Provider>
  );
};

export const useGhostMode = () => useContext(GhostModeContext);